import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';

import { SupportService } from '../services/support-service';
import { MasterService } from '../services/master-service';
import { AuthService } from '../services/auth.service';
import { ReportService } from '../services/report-service';
import { CommonService } from '../services/common-service';

@Component({
  templateUrl: '../main.component.html'
})

export class SupportListComponent implements OnInit {
  public menuName = "Support";
  public titleName = "Support";
  //public rowscount = 0;
  public edited = false;
  @ViewChild('cellBeginEditLog') cellBeginEditLog: ElementRef;
  @ViewChild('cellEndEditLog') cellEndEditLog: ElementRef;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('myDropDownList') myDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;

  delrows: Array<any> = [];
  selectedcell: any;
  errorMessage: any;
  supportContent: any;
  successMessage: any;
  loading_flg: boolean = true;
  first_flg: boolean = true;

  //get grid source
  constructor(
    private _masterService: MasterService, private _reportService: ReportService,  private _supportService: SupportService,
    private _router: Router, public dialog: MatDialog, private _com: CommonService) {
  }

  ngOnInit() {
    this.getCustomersDropDown();
    this.getDevicesDropDown();
    this.getSymptomsDropDown();
    this.getSupports();
  }

  getSupports() {
    this.loading_flg = true;
    if (!(this.first_flg)) {
      this.MyLoader.open();
    }
    this._supportService.getSupports().subscribe((data) => {
      this.source.localdata = data;
      //this.rowscount = data.length;
      this.dataAdapter.dataBind();
      if (!(this.first_flg)) {
        this.MyLoader.close();
      }
      this.first_flg = false;
      this.loading_flg = false;
    });
  }

  getCustomersDropDown() {
    this._masterService.getCustomersForDropDown().subscribe((data) => {
      this.customersSource.localdata = data;
    });
  }

  getDevicesDropDown() {
    this._masterService.getDevicesForDropDown().subscribe((data) => {
      this.devicesSource.localdata = data;
    });
  }

  getSymptomsDropDown() {
    this._masterService.getSymptomsForDropDown().subscribe((data) => {
      this.symptomsSource.localdata = data;
    });
  }

  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let deviceId = this.myGrid.getrowdata(selectedrowindex).device_id;
    let customerId = this.myGrid.getrowdata(selectedrowindex).customer_id;
    let id = this.myGrid.getrowdata(selectedrowindex).support_id;
    let dialogRef = this.dialog.open(PopupSupportComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        support_id: id,
        device_id: deviceId,
        customer_id: customerId
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getSupports();
      });
  }
  //tool bar
  ngAfterViewInit(): void {
    this.createButtons();
  }

  dropDownSource: string[] = ['Customer', 'MAC', 'Supported', 'Symptom', 'Description'];

  groups: any[] = [];
  getPagesize(): any {
    return 20;
  }
  //grid 
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'support_id', type: 'int' },
        { name: 'customer_id', type: 'int' },
        { name: 'customer_name', type: 'string' },
        { name: 'device_id', type: 'int' },
        //{ name: 'mac_address', type: 'string', map: 'device>mac_address' },
        //{ name: 'order_no', type: 'string', map: 'device>order_no' },
        //{ name: 'warranty', type: 'date', map: 'device>warranty' },
        { name: 'mac_address', type: 'string' },
        { name: 'supported', type: 'date' },
        { name: 'symptom_id', type: 'int' },
        { name: 'symptom_name', type: 'string' },
        { name: 'support_contents', type: 'string' }
      ],
      id: 'support_id',
      localdata: {},
      sortcolumn: 'customer_name'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source);

  getWidth(): any {
    return '100%';
  }
  getTotal(): any {
    return false;
  }

  devicesSource: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'device_id', type: 'int' },
        { name: 'mac_address', type: 'string' }
      ],
      localdata: {}
    };
  devicesAdapter: any = new jqx.dataAdapter(this.devicesSource, { autoBind: true });

  customersSource: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'customer_id', type: 'int' },
        { name: 'customer_name', type: 'string' }
      ],
      localdata: {}
    };
  customersAdapter: any = new jqx.dataAdapter(this.customersSource, { autoBind: true });

  symptomsSource: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'symptom_id', type: 'int' },
        { name: 'symptom_name', type: 'string' }
      ],
      localdata: {}
    };
  symptomsAdapter: any = new jqx.dataAdapter(this.symptomsSource, { autoBind: true });

  //columns
  columns: any[] =
    [
      { text: 'Id', datafield: 'support_id', hidden: true},
      {
        text: 'Customer', datafield: 'customer_id', displayfield: 'customer_name', width: '15%', columntype: 'dropdownlist', editable: false,
        createeditor: (row: number, column: any, editor: any): void => {
          // assign a new data source to the dropdownlist.
          //let list = ['Admin', 'Super AgentPerson', 'General AgentPerson'];
          editor.jqxDropDownList({ autoDropDownHeight: true, source: this.customersAdapter, valueMember: 'customer_id', displayMember: 'customer_name', placeHolder: "Please Select", });
        },
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'Customer is required' };
          }
          return true;
        },
      },
      {
        text: 'MAC', datafield: 'device_id', displayfield: 'mac_address', width: '15%', columntype: 'dropdownlist', editable: false, createeditor: (row: number, column: any, editor: any): void => {
          // assign a new data source to the dropdownlist.
          //let list = ['Admin', 'Super AgentPerson', 'General AgentPerson'];
          editor.jqxDropDownList({ autoDropDownHeight: true, source: this.devicesAdapter, valueMember: 'device_id', displayMember: 'mac_address', placeHolder: "Please Select", });
        },
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'MAC is required' };
          }
          return true;
        },
      },
      { text: 'Supported', datafield: 'supported', width: '10%', columntype: 'datetimeinput', cellsformat: 'MM/dd/yyyy', editable: false },
      {
        text: 'Symptom', datafield: 'symptom_id', displayfield: 'symptom_name', width: '20%', columntype: 'dropdownlist', editable: false, createeditor: (row: number, column: any, editor: any): void => {
          // assign a new data source to the dropdownlist.
          //let list = ['Admin', 'Super AgentPerson', 'General AgentPerson'];
          editor.jqxDropDownList({ autoDropDownHeight: true, source: this.symptomsAdapter, valueMember: 'symptom_id', displayMember: 'symptom_name', placeHolder: "Please Select", });
        },
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'Symptom is required' };
          }
          return true;
        },
      },
      {
        text: 'Description', datafield: 'support_contents', width: '40%', columntype: 'eidter', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 1000) {
            return { result: false, message: 'Description Code must be less than 1000 letters.' };
          }
          return true;
        }
      },
    ];

  groupsrenderer(text, group, expanded, data): any {
    var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    }
    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //add row
  generatedata(): any {
    let row = {};
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    row['support_id'] = 0;
    row['customer_id'] = 0;
    row['customer_name'] = "";
    row['device_id'] = 0;
    row['mac_address'] = "";
    row['supported'] = todayStr;
    row['symptom_id'] = 0;
    row['symptom_name'] = "";
    row['support_contents'] = "";

    return row;
  }

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    let addButtonContainer = document.createElement('div');
    //let deleteButtonContainer = document.createElement('div');
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    //let saveButtonContainer = document.createElement('div');
    addButtonContainer.id = 'addButton';
    //deleteButtonContainer.id = 'deleteButton';
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
    //saveButtonContainer.id = 'saveButton';
    addButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //saveButtonContainer.style.cssText = 'float: right; margin-right: 5px;';
    addButtonContainer.className = 'btn btn-default';
    //deleteButtonContainer.className = 'btn btn-default';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
    //saveButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(addButtonContainer);
    //buttonsContainer.appendChild(deleteButtonContainer);
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
    //buttonsContainer.appendChild(saveButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  createButtons(): void {
    let addButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;' title='Add'></span>"
    }
    let addButton = jqwidgets.createInstance('#addButton', 'jqxButton', addButtonOptions);
    //let deleteButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-remove' style='color:indianred;' title='Delete'></span>"
    //}
    //let deleteButton = jqwidgets.createInstance('#deleteButton', 'jqxButton', deleteButtonOptions);
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Reload'></span>"
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-search' style='color:slategrey;' title='Find'></span>"
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    //let saveButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-floppy-disk' style='color:#2E7D32;' title='Save'></span>"
    //}
    //let saveButton = jqwidgets.createInstance('#saveButton', 'jqxButton', saveButtonOptions);

    // add new row.
    addButton.addEventHandler('click', (event: any): void => {
      let selectedrowindex = this.myGrid.getselectedrowindex();
      let id = 0;
      let dialogRef = this.dialog.open(PopupSupportComponent, {
        width: '900px',
        //height: 'auto*',
        disableClose: true,//20191007 close無し
        data: {
          support_id: id
        }
      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          //20191008 自分のタイミングで更新するように
          //this.getSupports();
        });
    });
    // delete selected row.
    //deleteButton.addEventHandler('click', (event: any): void => {
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  let rowscount = this.myGrid.getdatainformation().rowscount;
    //  let id = this.myGrid.getrowid(selectedrowindex);
    //  this.myGrid.deleterow(id);
    //  this.delrows.push(id);
    //});
    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      this.getSupports();
      this.delrows = [];
      this.selectedcell = null;
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    // save records.
    //saveButton.addEventHandler('click', (event: any): void => {
    //  this.errorMessage = null;
    //  this.successMessage = 'You have successfully saved the data.';

    //  //confirm changes
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  //console.log("this.selectedcell :" + this.selectedcell);
    //  this.myGrid.endcelledit(selectedrowindex, this.selectedcell, false);

    //  for (var i = 0; i < this.myGrid.getrows().length; i++) {
    //    let support = this.myGrid.getrowdata(i);
    //    if (support.customer_id == ''
    //      || support.device_id == ''
    //      || support.symptom_id == ''
    //      || support.support_contents.length > 1000) {
    //      this.errorMessage = "Input is invalid. Please check the data.";
    //      this.successMessage = null;
    //      return;
    //    }
    //  }

    //  let rows = this.myGrid.getrows();

    //  rows.forEach(support => {
    //    if (support.support_id == 0) {
    //      //console.log("support :" + support);
    //      this._supportService.addSupport(support)
    //        .subscribe(
    //          data => {
    //            //this.getSupports();
    //            let index = this.myGrid.getrowboundindexbyid(support.support_id);
    //            support.support_id += data;
    //            this.myGrid.setcellvalue(index, "support_id", data);
    //          },
    //          error => {
    //            this.successMessage = null;
    //            if (error._body != null) {
    //              this.errorMessage += "Some data have not been saved. " + error._body;
    //            } else {
    //              this.errorMessage += error;
    //            }
    //          })
    //    }
    //    else {
    //      this._supportService.updateSupport(support)
    //        .subscribe(
    //          data => {
    //            //this.getSupports();
    //          },
    //          error => {
    //            this.successMessage = null;
    //            if (error._body != null) {
    //              this.errorMessage += "Some data have not been saved. " + error._body;
    //            } else {
    //              this.errorMessage += error;
    //            }
    //          })
    //    }
    //  });
    //  this.delrows.forEach(supportId => {
    //    if (supportId != 0) {
    //      this._supportService.deleteSupport(supportId).subscribe(
    //        data => {
    //          //this.getSupports();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows = [];
    //  this.selectedcell = null;
    //});
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.myDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      case 0:
        datafield = 'support_id';
        break;
      case 1:
        datafield = 'support_id';
        break;
      case 2:
        datafield = 'support_no';
        break;
      case 3:
        datafield = 'device_id';
        break;
      case 4:
        datafield = 'mac_address';
        break;
      case 5:
        datafield = 'order_no';
        break;
      //case 6:
      //  datafield = 'warranty';
      //  break;
      case 6:
        datafield = 'lent';
        break;
      case 7:
        datafield = 'returned';
        break;
      case 8:
        datafield = 'support_contents';
        break;
      case 9:
        datafield = 'dispose_flg';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  //clear btn
  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //edit function
  rowValues: string = '';
  myGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.selectedcell = args.datafield;
  };
  myGridOnCellEndEdit(event: any): void {
  };

  //print pdf
  printBtnOnClick() {
    this._reportService.showPrint(this.myGrid, 'Support');

  };

  //export excel
  excelBtnOnClick() {
    this._reportService.exportExcel(this.myGrid, 'Support');
  };

  onPageChanged(): void {
    this.myGrid.expandallgroups();
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }

  closeErrorMessage() {
    this.errorMessage = null;
  }
}

//****************************************************
// Popup
//****************************************************

@Component({
  selector: 'app-popup-support',
  templateUrl: 'popup-support.component.html',
  styleUrls: ['./popup-support.component.css'],
})
  export class PopupSupportComponent implements OnInit {
  @ViewChild('editorSupport') myEditor: jqxEditorComponent;
  title: string = "(Create)";
  supportForm: FormGroup;
  errorMessage: any;
  successMessage: any;
  selectedcell: any;
  delrows: Array<any> = [];
  customerList: Array<any> = [];
  searchedList: Array<any> = [];
  deviceList: Array<any> = [];
  searchedDeviceList: Array<any> = [];
  symptomList: Array<any> = [];
  user: any;

  constructor(
    public dialogRef: MatDialogRef<PopupSupportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _masterService: MasterService,
    private _supportService: SupportService,
    private _authService: AuthService,
    private _fb: FormBuilder, private _com: CommonService
  )
  {
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.user = this._authService.getAuthLoginName();
    this.supportForm = this._fb.group({
      support_id: 0,
      supported: todayStr,
      customer_id: 0,
      customer_name: ['', Validators.required],
      device_id: 0,
      mac_address: ['', Validators.required],
      symptom_id: 0,
      symptom_name: ['', Validators.required],
      updated_by: this.user,
      updated_date: todayStr,
      support_contents: ''
    })
  }

  ngOnInit() {
    this.getCustomersDropDown();
    this.getDevicesDropDownByCustomerId();
    this.getSymptomsDropDown();
    this.getSupportById(this.data.support_id);
  }

  ngAfterViewInit(): void
    {
      this.myEditor.createComponent({});
    }   


  getCustomersDropDown() {
    this._masterService.getCustomersForDropDown().subscribe((data) => {
      this.customerList = data;
    });
  }

  getDevicesDropDownByCustomerId() {
    this._masterService.getDevicesDropDownByCustomerId(this.data.customer_id).subscribe((data) => {
      this.deviceList = data;
    });
  }

  getSymptomsDropDown() {
    this._masterService.getSymptomsForDropDown().subscribe((data) => {
      this.symptomList = data;
    });
  }

  getSupportById(id) {
    if (id > 0) {
      this.title='(Edit/View)'
      this._supportService.getSupportById(id)
        .subscribe(
        res => {
            this.supportForm.setValue(res);
            this.myEditor.val(res.support_contents);
            this.onKey(res.customer_name);
        },
        error => this.errorMessage = error._body
      );
    }
  }

  getWidth(): any {
    return '100%';
  }

  getHeight(): any {
    return '60%';
  }


  supportTools: string = 'datetime | print | clear | backcolor | font | bold italic underline';

  createCommand = (name: string): any => {
    switch (name) {
      case 'datetime':
        return {
          type: 'list',
          tooltip: 'Insert Date/Time',
          init: (widget: any): void => {
            widget.jqxDropDownList({ placeHolder: 'Insert Custom HTML', width: 170, source: ['Insert Time', 'Insert Date'], autoDropDownHeight: true });
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
            widget.jqxDropDownList('clearSelection');
          },
          action: (widget: any, editor: any): any => {
            let widgetValue = widget.val();
            let date = new Date();
            // return object with command and value members.
            return { command: 'inserthtml', value: widgetValue == 'Insert Time' ? date.getHours() + ':' + date.getMinutes() : date.getDate() + '-' + (date.getMonth() + 1).toString() + '-' + date.getFullYear() };
          }
        }
      case 'print':
        return {
          type: 'button',
          tooltip: 'Print',
          init: (widget: any): void => {
            widget.jqxButton({ height: 25, width: 40 });
            widget.html('<span style="line-height: 24px;">Print</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): void => {
            // return nothing and perform a custom action.
            this.myEditor.print();
          }
        }
      case 'clear':
        return {
          type: 'button',
          tooltip: 'Clear',
          init: (widget: any): void => {
            widget.jqxButton({ height: 25, width: 40 });
            widget.html('<span style="line-height: 24px;">Clear</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): void => {
            // return nothing and perform a custom action.
            this.myEditor.val('')
          }
        }
      case 'backcolor':
        return {
          type: 'colorPicker',
          tooltip: 'Background',
          init: (widget: any): void => {
            widget.jqxDropDownButton({ width: 170 });
            widget.jqxDropDownButton('setContent', '<span style="line-height: 24px;">Choose Background</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): void => {
            // return nothing and perform a custom action.
            let color = widget.val();
            editor.css('background', color);
          }
        }
    }
  };
  //localization: any = {
  //    'bold': 'Fett',
  //    //'italic': 'Kursiv',
  //    //'underline': 'Unterstreichen',
  //    //'format': 'Block-Format',
  //    //'font': 'Schriftname',
  //    //'size': 'Schriftgröße',
  //    'color': 'Textfarbe',
  //    //'background': 'Hintergrundfarbe',
  //    //'left': 'Links ausrichten',
  //    //'center': 'Mitte ausrichten',
  //    //'right': 'Rechts ausrichten',
  //    //'outdent': 'Weniger Einzug',
  //    //'indent': 'Mehr Einzug',
  //    //'clean': 'Formatierung entfernen'
  //};

  customerOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getCustomerById(value)
        .subscribe(
          data => {
            this.customer_id.setValue(data.customer_id);
            this.customer_name.setValue(data.name);
          });
      this._masterService.getDevicesDropDownByCustomerId(value)
        .subscribe(
          data => {
            this.deviceList = data;
          });
    }
    else {
      this.customer_id.setValue(0);
      this.customer_name.setValue(null);
    }
    this.device_id.setValue(0);
    this.mac_address.setValue(null);
  }

  macOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getDeviceById(value)
        .subscribe(
          data => {
            this.mac_address.setValue(data.mac_address);
          });
    }
    else {
      this.mac_address.setValue(null);
    }
  }

  symptomOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getSymptomById(value)
        .subscribe(
          data => {
            this.symptom_name.setValue(data.description);
          });
    }
    else {
      this.symptom_name.setValue(null);
    }
  }
  //Save Data
  saveSupport() {
    //check form
    if (this.supportForm.invalid) {
      this.errorMessage = 'Please enter all required fields.';
      return;
    }

    this.errorMessage = null;
    this.successMessage = null;

    this.supportForm.value.support_contents = this.myEditor.val();
    if (this.support_id.value == 0) {
      this._supportService.addSupport(this.supportForm.value)
        .subscribe(
          data => {
            if (data > 0) {
                this.successMessage = "You have successfully added the data.";
                this.getSupportById(data);
            } else {
              this.errorMessage = "Failed to save the data. ";
            }
          },
        error => {
          if (error != null) {
            this.errorMessage = error._body;
          }
          else {
            this.errorMessage = "Failed to save the data. ";
          }
          });
    }
    else {
      this._supportService.updateSupport(this.supportForm.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully updated the data.";
              this.getSupportById(data);
            } else {
              this.errorMessage = "Failed to update the data. ";
            }
          },
        error => {
          if (error != null) {
            this.errorMessage = error._body;
          }
          else {
            this.errorMessage = "Failed to update the data. ";
          }
          });
    }
  }

  //Delete Data
  deleteSupport() {
    if (!confirm("Are you sure you want to delete this data?")) {
      console.log('no');
      return;
    }

    if (this.support_id.value != 0) {

      let id = this.support_id.value;

      this._supportService.deleteSupport(id)
        .subscribe(
          data => {
            if (data == 1) {
              this.dialogRef.close();
            }
            else {
              this.errorMessage = ' Failed to delete the data.';
            }
          },
          error => {
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to delete the data. ";
            }
          }
        )
    };
  }

  // Receive user input and send to search method**
  onKey(value) {
    this.searchedList = [];
    //let filter = value.toLowerCase();
    if (typeof value != "undefined" && value != null && value != "") {
      this._masterService.getListCustomersForDropDownSearchList(value)
        .subscribe(
          res => {
            this.searchedList = res;
            //this.searchedList.push(res); //error
          },
          error => this.errorMessage = error._body
      );
      this._masterService.getDevicesDropDownByCustomerName(value)
        .subscribe(
          data => {
            this.deviceList = data;
          });
    } else {
      this.customer_id.setValue(0);
      this.customer_name.setValue("");
      this.device_id.setValue(0);
      this.mac_address.setValue("");
    }
  }

  //// Receive user input and send to search method**
  //onKeyForMAC(value) {
  //  this.searchedDeviceList = [];
  //  let filter = value.toLowerCase();
  //  if (typeof value != "undefined" && value != null) {
  //    this._masterService.getListDevicesForDropDownSearchList(value)
  //      .subscribe(
  //        res => {
  //          this.searchedList = res;
  //          //this.searchedList.push(res); //error
  //        },
  //        error => this.errorMessage = error._body
  //      );
  //  }
  //}

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }

  closeErrorMessage() {
    this.errorMessage = null;
  }

  get support_id() { return this.supportForm.get('support_id'); }
  get supported() { return this.supportForm.get('supported'); }
  get device_id() { return this.supportForm.get('device_id'); }
  get mac_address() { return this.supportForm.get('mac_address'); }
  get customer_id() { return this.supportForm.get('customer_id'); }
  get customer_name() { return this.supportForm.get('customer_name'); }
  get symptom_id() { return this.supportForm.get('symptom_id'); }
  get symptom_name() { return this.supportForm.get('symptom_name'); }
  get support_contents() { return this.supportForm.get('support_contents'); }
}





// WEBPACK FOOTER //
// ./src/app/support/support-list.component.ts